import React from "react";
import { useIntl } from "react-intl";
import { BulkTest, BulkTestStatusType, Page, BulkTestPageParam } from "@/model";
import Tooltip from "@/component/Tooltip";
import SortButton from "@/component/SortBurtton";

import BulkTestFragment from "./BulkTestFragment";


interface BulkTestTableProps {
    page?: Page<BulkTest>;
    pageParam: BulkTestPageParam;
    onClickSortHead: (key: BulkTestPageParam["sortKey"]) => void;
}

const BulkTestTable: React.FC<BulkTestTableProps> = (props) => {
    const { page, pageParam, onClickSortHead } = props;

    const intl = useIntl();

    const statusLabelLookup: Record<BulkTestStatusType, string> = {
        DONE: intl.formatMessage({ id: "i09011" }),
        IN_PROGRESS: intl.formatMessage({ id: "i09012" }),
        ERROR: intl.formatMessage({ id: "i09014" }),
        CANCELED: intl.formatMessage({ id: "i09038" })
    };

    return (
        <div role="table"
             className="selection-table grid-table-bulk-test"
        >
            <div role="rowgroup"
                 className="selection-table-thead"
            >
                <div role="columnheader"
                     className="selection-table-th pl-[25px]"
                >
                    {intl.formatMessage({ id: "i09003" })}
                </div>
                <div role="columnheader"
                     className="selection-table-th pl-[15px]"
                >
                    {intl.formatMessage({ id: "i09005" })}
                </div>
                <div role="columnheader"
                     className="selection-table-th pl-[15px]"
                >
                    <div className="flex items-center gap-1.5">
                        {intl.formatMessage({ id: "i09007" })}
                        <Tooltip message={intl.formatMessage({ id: "i09045" })} />
                    </div>
                </div>
                <div role="columnheader"
                     className="selection-table-th pl-[15px]"
                >
                    {intl.formatMessage({ id: "i09010" })}
                </div>
                <div role="columnheader"
                     className="selection-table-th group pl-[15px]"
                >
                    <SortButton order={pageParam.sort}
                                active={pageParam.sortKey === "success_rate"}
                                onClick={() => onClickSortHead("success_rate")}
                    >
                        {intl.formatMessage({ id: "i09009" })}
                    </SortButton>
                </div>
                <div role="columnheader"
                     className="selection-table-th group pl-[15px]"
                >
                    <SortButton order={pageParam.sort}
                                active={pageParam.sortKey === "created_at"}
                                onClick={() => onClickSortHead("created_at")}
                    >
                        {intl.formatMessage({ id: "i09008" })}
                    </SortButton>
                </div>
            </div>
            <div role="rowgroup"
                 className="selection-table-tbody"
            >
                {page?.content.map(bulkTest => (
                    <BulkTestFragment key={bulkTest.id}
                                      bulkTest={bulkTest}
                                      statusLabel={statusLabelLookup[bulkTest.status]}
                                      searchKeyword={pageParam.keyword}
                    />
                ))}
                {!page?.content?.length && (
                    <div className="empty-table">
                        {intl.formatMessage({ id: pageParam.keyword ? "b0014" : "b0018" })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BulkTestTable;